import { Component, Element, Event, EventEmitter, h, Prop, State, Watch } from '@stencil/core';
import { ActionBarConfig, YoutubeConfig } from '../../../../../interfaces';
import { timePassed } from '../../../../../util';

@Component({
  tag: 'zeudy-action-bar-controller',
  styleUrl: 'zeudy-action-bar-controller.scss',
  shadow: true,
})
export class zeudyActionBar {
  @Element() el: HTMLElement;

  @Prop() ended: boolean;
  @Prop() config: ActionBarConfig;
  @Prop({ reflect: true }) currentTime: number;
  @Prop({ reflect: true }) duration: number;
  @Prop() direction?: 'rtl';
  @Prop() youtube?: YoutubeConfig;

  @State() show: boolean = false;
  @State() youtubeRenderKey: number = 1;
  @State() percentagePassed: number = 0;
  @Event() actionBarStateChange: EventEmitter<boolean>;

  componentWillLoad() {
    this.handleDuration();
  }

  /**
   * Wait for duration to start before checking time
   * @returns void
   */
  @Watch('duration')
  handleDuration() {
    this.handleTime();
  }

  /**
   * Handle with the player is ended
   * @param val
   * @returns
   */
  @Watch('ended')
  handleEnded(val) {
    if (val) {
      if (this?.config?.percentage_start !== 100) return;
      this.show = true;
    }
  }

  @Watch('currentTime')
  @Watch('duration')
  handlePercentagePassed() {
    this.percentagePassed = (this.currentTime / this.duration) * 100;
  }

  /**
   * When current time changes, check to see if we should
   * enable the overlay
   * @returns void
   */
  @Watch('currentTime')
  handleTime() {
    this.checkTime();
  }

  /**
   * Set enabled/disabled based on time that has passed
   */
  checkTime() {
    if (window?.wp?.blocks) {
      this.show = true;
      return;
    }
    // if ( this.config?.percentage_start === 0) {
    //   this.show = true;
    // } else {

    // console.log(this.currentTime, this.duration, this.config?.percentage_start);
    this.show = timePassed({
      current: this.currentTime,
      duration: this.duration,
      showAfter: this.config?.percentage_start,
    });
  }

  @Watch('config')
  handleButtonCountChange(newVal, oldVal) {
    if (newVal?.button_count !== oldVal?.button_count) {
      this.youtubeRenderKey++;
    }
    if (newVal?.enabled) {
      this.handleDuration();
    }
  }

  youtubeButton() {
    if (this.config?.button_type !== 'youtube' || !this.youtube?.channelId) {
      return;
    }

    return <zeudy-youtube-subscribe-button key={this.youtubeRenderKey} channel={this.youtube?.channelId} showCount={this.config?.button_count}></zeudy-youtube-subscribe-button>;
  }

  customButton() {
    if (this.config?.button_type !== 'custom') {
      return;
    }

    return (
      <zeudy-player-button
        type="primary"
        size="small"
        href={this.config?.button_link?.url}
        target={this.config?.button_link?.opensInNewTab ? '_blank' : '_self'}
        style={{
          '--zeudy-player-button-border-radius': `${this.config?.button_radius}px`,
          ...(this.config?.button_color
            ? {
                '--zeudy-player-button-color': `${this.config?.button_color}`,
              }
            : {}),
          ...(this.config?.button_text_color
            ? {
                '--zeudy-player-button-text': `${this.config?.button_text_color}`,
              }
            : {}),
        }}
      >
        {this.config?.button_text}
      </zeudy-player-button>
    );
  }
  @Watch('show')
  handleCtaStateChange(val) {
    this.actionBarStateChange.emit(val);
  }
  render() {
    return (
      <zeudy-action-bar-ui
        open={this.show}
        style={{
          '--zeudy-action-bar-background': this.config?.background_color || '#1d1d1d',
        }}
      >
        {this.config?.text}

        <div slot="button">
          {this.youtubeButton()}
          {this.customButton()}
        </div>
      </zeudy-action-bar-ui>
    );
  }
}
